import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=adfb878a&scoped=true"
import script from "./SelectProject.vue?vue&type=script&lang=js"
export * from "./SelectProject.vue?vue&type=script&lang=js"
import style0 from "./SelectProject.vue?vue&type=style&index=0&id=adfb878a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfb878a",
  null
  
)

export default component.exports